export const CAR_CONSTANTS = {
  carCoverTypes: {
    comprehensiveUnlimited: 'CC',
    comprehensiveFixedKm: 'CP',
    basic: 'CB'
  },
  legacyCoverLevels: {
    CC: 'comp',
    CP: 'payd',
    CB: 'tppd'
  },
  legacyCoverTypes: {
    CC: 'comp',
    CP: 'comp',
    CB: 'tp'
  }
};
